import { useState } from "react";

const nav = [
  { href: "#meaning", label: "什么意思" },
  { href: "#decode", label: "数字解读" },
  { href: "#compare", label: "说法对比" },
  { href: "#origin", label: "由来" },
  { href: "#use", label: "怎么接" },
  { href: "#faq", label: "常见问答" },
];

export default function Masthead() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/85 backdrop-blur">
      <div className="wrap flex items-center justify-between py-3">
        <h1 className="m-0 flex items-center gap-3">
          <a href="#top" className="flex items-center gap-3">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-poster text-lg text-background-50">
              91
            </span>
            <span className="eyebrow text-xl font-black tracking-wide text-foreground-950">
              吃瓜<span className="text-primary-600">91</span>
              <span className="ml-2 align-middle text-[11px] font-medium text-foreground-500">数字梗小词典</span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-6 md:flex" aria-label="词条目录">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#copy"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-clipboard-line h-4 w-4 flex items-center justify-center" />
            复制释义
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-800 md:hidden"
          >
            <i className={`h-5 w-5 flex items-center justify-center ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="faq-open border-t border-background-200 bg-background-50 md:hidden">
          <div className="wrap flex flex-col py-3">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-200/60 py-3 text-sm font-medium text-foreground-800"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#copy"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-clipboard-line h-4 w-4 flex items-center justify-center" />
              复制释义
            </a>
          </div>
        </div>
      )}
    </header>
  );
}